export default __webpack_public_path__ + "static/media/waitPayment.30d10306.svg";